import React, { Component, Fragment } from "react";
import { TouchableWithoutFeedback, Image } from "react-native";
import { Header, Icon, Text, View, Button, H1, H3 } from "native-base";
import I18n from "../../i18n";
import LinearGradient from "react-native-linear-gradient";
import wcColors from "../../../native-base-theme/variables/wcColors";
import styles from "../../styles";

export default class Welcome1 extends Component {
  static navigationOptions = {
    header: null
  };

  render() {
    return (
      <Fragment>
        <LinearGradient
            colors={wcColors.welcome.backgroundGradient}
            locations={wcColors.welcome.gradientLocations}
            start={wcColors.welcome.gradientStart}
            end={wcColors.welcome.gradientEnd}
            style={styles.gradient}
        />

        <TouchableWithoutFeedback onPress={() => this.props.navigation.goBack()} >
          <Header hasTabs welcome>
            <Icon name={I18n.isRTL ? "arrow-forward" : "arrow-back"} /><Text numberOfLines={1}>{I18n.t("appStrings.NAV_BACK")}</Text>
          </Header>
        </TouchableWithoutFeedback>

        <View style={{flex:1}}>
          <View style={{flex:1, justifyContent: 'center', alignItems: 'center'}}>
            <H3 style={{color:'white', fontWeight: 'bold'}}>{I18n.t("appStrings.WELCOME_PANEL_2_TITLE")}</H3>
          </View>
          <View style={{flex:2, flexDirection: 'row'}}>
            <View style={{flex:1}}>
              <Image
                style={{flex:1, height: undefined, width: undefined, marginLeft:30}}
                source={require('../../assets/img/welcome/welcome2-1.png')}
                resizeMode="contain"
              />
            </View>
            <View style={{flex:2}}>
              <Text style={{textAlign:'right', padding:20, color:'white'}}>{I18n.t("appStrings.WELCOME_PANEL_2_TEXT_1")}</Text>
            </View>
          </View>
          <View style={{flex:2, flexDirection: 'row'}}>
            <View style={{flex:2}}>
              <Text style={{padding:20, color:'white'}}>{I18n.t("appStrings.WELCOME_PANEL_2_TEXT_2")}</Text>
            </View>
            <View style={{flex:1}}>
              <Image
                style={{flex:1, height: undefined, width: undefined, marginRight:30}}
                source={require('../../assets/img/welcome/welcome2-2.png')}
                resizeMode="contain"
              />
            </View>
          </View>
          <View style={{flex:1, justifyContent: 'flex-end', marginBottom: 36}}>
            <Button
              testID={"nextButton"}
              rounded
              welcome
              onPress={() => this.props.navigation.navigate("Welcome3")}
            >
              <Text numberOfLines={1} uppercase={true}>
                {I18n.t("appStrings.NAV_CONTINUE")}
              </Text>
            </Button>
          </View>
        </View>

      </Fragment>
    );
  }

}